//@flow
import { reduxForm } from 'redux-form';
import ValidationService from '../../lib/validation';
import GenericLogin from './GenericLogin';

const validate = values => ({
  email: ValidationService.validateEmail(values.email),
  password: ValidationService.validatePresence(values.password),
});

export default reduxForm({ form: 'login', validate })(GenericLogin);
